'use strict';

var _ = require('lodash');
var StaticDataService = function StaticDataService(App, restangular, $q) {
  function freeze(array) {
    if (_.isArray(array)) {
      for (var i = 0; i < array.length; i++) {
        array[i] = Object.freeze(array[i]);
      }
      return Object.freeze(array);
    }
    return array;
  }
  function loadEntities() {
    return restangular.one('staticdata').one('entity').get().then(function (data) {
      App.entities = freeze(data.entities);
    });
  }
  function loadHubs() {
    return restangular.one('staticdata').one('hubs').get().then(function (data) {
      App.hubs = freeze(data.hub);
    });
  }
  function loadMarkets(reset) {
    App.markets = reset ? [] : App.markets || [];
    return restangular.one('staticdata').one('markets').get().then(function (data) {
      data.market = data.market || [];
      var marketStrToMarketObjectMap = data.market.reduce(function (map, obj) {
        map[obj.origin + obj.destination] = obj;
        return map;
      }, {});
      _.forEach(App.markets, function (appMarket) {
        var market = marketStrToMarketObjectMap[appMarket.origin + appMarket.destination];
        if (!_.isNil(market)) {
          _.merge(appMarket, market);
        }
      });
      App.markets = _.chain(App.markets).concat(data.market).uniqBy(function (item) {
        return item.origin + item.destination;
      }).value();
    });
  }
  function loadFpCabins() {
    var defer = $q.defer();
    App.cabinsConfig = [];
    restangular.one('staticdata').one('fpCabins').get().then(function (data) {
      App.cabinsConfig = freeze(data.fpCabins);
    })["finally"](function () {
      defer.resolve();
    });
    return defer.promise;
  }
  function loadFpMarkets() {
    App.markets = App.markets || [];
    restangular.one('staticdata').one('fpMarkets').get().then(function (data) {
      var fpMarkets = _.chain(data.fpMarkets).transform(function (result, market) {
        result.push({
          origin: market.marketOrigin,
          destination: market.marketDestination,
          owner: market.owner
        });
      }, []).value();
      _.forEach(App.markets, function (appMarket) {
        var fpMarket = _.find(fpMarkets, {
          origin: appMarket.origin,
          destination: appMarket.destination
        });
        if (!_.isNil(fpMarket)) {
          _.merge(appMarket, fpMarket);
          _.remove(fpMarkets, fpMarket);
        }
      });
      App.markets = _.chain(App.markets).concat(fpMarkets).uniqBy(function (item) {
        return item.origin + item.destination;
      }).value();
    });
  }
  function loadDaPoses() {
    App.daPoses = App.daPoses || [];
    if (_.isEmpty(App.daPoses)) {
      return restangular.one('staticdata').one('daPoses').get().then(function (data) {
        var appDaPoses = App.daPoses;
        var dataDaPos = data.daPos || [];
        App.daPoses = aggregatePoses(appDaPoses, dataDaPos);
      });
    }
  }
  function aggregatePoses(appPoses, dataPos) {
    _.forEach(appPoses, function (appPos) {
      var pos = _.find(dataPos, {
        origin: appPos.origin,
        destination: appPos.destination,
        spos: appPos.spos
      });
      if (!_.isNil(pos)) {
        _.merge(appPos, pos);
        _.remove(dataPos, pos);
      }
    });
    return _.chain(appPoses).concat(dataPos).uniqBy(function (item) {
      return item.origin + item.destination + item.spos;
    }).value();
  }
  function loadLegs() {
    return restangular.one('staticdata').one('legs').get().then(function (data) {
      App.legs = freeze(data.leg);
    });
  }
  function loadSeasons() {
    return restangular.one('staticdata').one('seasons').get().then(function (data) {
      App.seasons = freeze(data.season);
    });
  }
  function loadFlightNumbers() {
    return restangular.one('staticdata').one('flightNumbers').get().then(function (data) {
      App.flightNumbers = freeze(data.flightNumber);
    });
  }
  function loadFlightDowGroups() {
    return restangular.one('staticdata').one('flightDowGroups').get().then(function (data) {
      App.flightDowGroups = freeze(data.dowGroup);
    });
  }
  function loadMarketDowGroups() {
    return restangular.one('staticdata').one('marketDemandDowGroups').get().then(function (data) {
      App.marketDowGroups = freeze(data.dowGroup);
    });
  }
  function loadOperatingCarriers() {
    return restangular.one('staticdata').one('operatingCarriers').get().then(function (data) {
      App.operatingCarriers = freeze(data.operatingCarrier);
    });
  }
  function loadPoses() {
    App.poses = App.poses || [];
    if (_.isEmpty(App.poses)) {
      return restangular.one('staticdata').one('poses').get().then(function (data) {
        var appPoses = App.poses;
        var dataPos = data.pos || [];
        App.poses = aggregatePoses(appPoses, dataPos);
      });
    }
  }
  function loadOptimizationRules() {
    App.optimizationRulesList = [];
    return restangular.one('rules').get({
      filter: 'isUserOverride==false;type==optimization'
    }).then(function (data) {
      if (data && data.detailedRules) {
        App.optimizationRulesList = _.map(data.detailedRules, function (rule) {
          return {
            ruleName: rule.name,
            ruleId: rule.technicalId
          };
        });
      }
    });
  }
  function loadFlightTags() {
    return restangular.one('domain').one('flightTags').get({
      pageLimit: '-1'
    }).then(function (data) {
      var flightTagNames = _.transform(data.results, function (result, current) {
        result.push({
          value: current.flightTagName
        });
      });
      App.flightTags = data.results;
      App.flightTagNames = _.uniqBy(flightTagNames, 'value');
    });
  }
  function freezeMarketsAndPos() {
    if (!_.isNil(App.markets)) {
      App.markets = freeze(_.clone(App.markets));
    }
    if (!_.isNil(App.poses)) {
      App.poses = freeze(_.clone(App.poses));
    }
  }
  return {
    loadEntities: loadEntities,
    loadFlightTags: loadFlightTags,
    loadMarkets: loadMarkets,
    loadFpMarkets: loadFpMarkets,
    loadLegs: loadLegs,
    loadSeasons: loadSeasons,
    loadFlightNumbers: loadFlightNumbers,
    loadFlightDowGroups: loadFlightDowGroups,
    loadMarketDowGroups: loadMarketDowGroups,
    loadPoses: loadPoses,
    loadOptimizationRules: loadOptimizationRules,
    loadOperatingCarriers: loadOperatingCarriers,
    loadHubs: loadHubs,
    loadFpCabins: loadFpCabins,
    loadDaPoses: loadDaPoses,
    freezeMarketsAndPos: freezeMarketsAndPos
  };
};
StaticDataService.$inject = ['App', 'Restangular', '$q'];
module.exports = StaticDataService;